// Only support kids which was born starting in 2020 or later
export const SUPPORTED_START_BIRTH_YEAR = 2020;

// Finnish display time format
export const DEFAULT_DATE_FORMAT = 'd.M.yyyy';

// Backend allowed time format
export const BACKEND_DATE_FORMAT = 'yyyy-MM-dd';

// HH.MM
export const DEFAULT_TIME_FORMAT = 'HH:mm';

export const DEFAULT_TIME_ZONE = 'Europe/Helsinki';
